<template>
  <img :src="resolvedSrc" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { getTheme, onThemeChange, themedImage } from '@/utils/theme.js';

export default {
  name: 'ThemeImage',
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentTheme: getTheme(),
      unsubscribe: null
    };
  },
  computed: {
    resolvedSrc() {
      return themedImage(this.src, this.currentTheme);
    }
  },
  created() {
    this.unsubscribe = onThemeChange(theme => {
      if (this.currentTheme !== theme) {
        this.$set(this, 'currentTheme', theme);
      }
    });
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
};
</script>
